import { Row, Col, DatePicker, Select, Flex, Table, Button, Tag } from "antd";

import { GET } from "../../../providers/useAxiosQuery";
import { useEffect, useState } from "react";
import ModalReport from "./components/ModalReport";
import {
	TablePagination,
	TableShowingEntriesV2,
	useTableScrollOnTop,
} from "../../../providers/CustomTableFilter";
import FloatSelect from "../../../providers/FloatSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import dayjs from "dayjs";

export default function PageReport() {
	const [toggleModalReport, setToggleModalReport] = useState({
		open: false,
		data: null,
	});

	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_order: "desc",
		sort_field: "fullname",
		semester: "",
		exam_date: [],
		exam_date_string: [],
	});

	const { data: dataDepartment } = GET(`api/department`, "department_dropdown");
	const { data: dataSemester } = GET(`api/semester`, "semester");
	const { data: dataExamCategory } = GET(
		`api/exam_category`,
		"exam_category_list"
	);
	const { data: dataStudentExam, refetch: refetchStudentExam } = GET(
		`api/student_exam?${new URLSearchParams(tableFilter)}`,
		"student_exam"
	);

	useEffect(() => {
		refetchStudentExam();

		return () => {};
	}, [tableFilter]);

	const onChangeTable = (pagination, filters, sorter) => {
		setTableFilter((prevState) => ({
			...prevState,
			sort_field: sorter.columnKey,
			sort_order: sorter.order ? sorter.order.replace("end", "") : null,
			page: 1,
			page_size: "50",
		}));
	};

	useTableScrollOnTop("tbl_wrapper_report", "tbl_wrapper_report");

	console.log("tableFilter test: ", tableFilter);

	// console.log("dataStudentExam test: ", dataStudentExam);
	// console.log("dataDepartment test: ", dataDepartment);

	return (
		<Row gutter={[12, 12]} id="tbl_wrapper_report">
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex className="flex-wrapper-filter" gap={10}>
					<Col xs={24} sm={24} md={6} lg={6} xl={6}>
						<DatePicker.RangePicker
							className="w-100"
							format={["MM/DD/YYYY", "MM/DD/YYYY"]}
							value={tableFilter.exam_date}
							allowClear
							onChange={(date, dateString) => {
								setTableFilter((prev) => ({
									...prev,
									exam_date: date,
									exam_date_string: dateString,
								}));
							}}
						/>
					</Col>

					<Col xs={24} sm={24} md={6} lg={6} xl={6}>
						<FloatSelect
							label="Department"
							placeholder="Select Department/s"
							className="w-100"
							multi="multiple"
							allowClear
							showSearch
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
							options={
								dataDepartment && dataDepartment.data
									? dataDepartment.data.map((item) => ({
											value: item.id,
											label: item.department_name,
									  }))
									: []
							}
							value={tableFilter.department_id || null}
							onChange={(value) => {
								setTableFilter((prev) => ({
									...prev,
									department_id: value,
								}));
							}}
						/>
					</Col>

					<Col xs={24} sm={24} md={6} lg={6} xl={6}>
						<FloatSelect
							label="Semester"
							placeholder="Select Semester"
							className="w-100"
							allowClear
							showSearch
							value={tableFilter.semester || null}
							options={
								dataSemester && dataSemester.data
									? dataSemester.data.map((item) => ({
											label: item.semester,
											value: item.semester,
									  }))
									: []
							}
							onChange={(value) => {
								setTableFilter((prev) => ({
									...prev,
									semester: value,
								}));
							}}
						/>
					</Col>
				</Flex>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div className="tbl-top-filter">
					<Flex gap={10}>
						<Button
							type="primary"
							icon={<FontAwesomeIcon icon={faDownload} />}
							iconPosition="end"
							onClick={() => {
								setToggleModalReport({
									open: true,
									data: {
										department_name: tableFilter.department_name,
										date_range: tableFilter.exam_date_string,
									},
								});
							}}
						>
							Export Pdf
						</Button>
					</Flex>
				</div>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24}>
				<Table
					id="tbl_wrapper_report"
					className="ant-table-default ant-table-striped"
					dataSource={dataStudentExam && dataStudentExam.data.data}
					rowKey={(record) => record.id}
					pagination={false}
					bordered={false}
					onChange={onChangeTable}
					scroll={{ x: "max-content" }}
					sticky
				>
					<Table.Column
						title="Student Name"
						key="fullname"
						dataIndex="fullname"
						sorter={(a, b) => a.fullname.localeCompare(b.fullname)}
						sortDirections={["descend", "ascend"]}
						width={200}
					/>

					<Table.Column
						title="Exam Schedule"
						key="exam_schedule_id"
						dataIndex="exam_schedule_id"
						sorter={(a, b) => a.exam_schedule_id - b.exam_schedule_id}
						defaultSortOrder="ascend"
						width={200}
						render={(text, record) => (
							<>
								{dayjs(record.exam_date).format("MMMM DD, YYYY")} ({" "}
								{record.exam_time} )
							</>
						)}
					/>

					<Table.Column
						title="Exam Category"
						key="exam_category"
						dataIndex="exam_category"
						sorter={(a, b) => a.exam_category.localeCompare(b.exam_category)}
						defaultSortOrder="ascend"
						width={150}
						render={(text, record) => (
							<>
								{record.exam_category}{" "}
								<Tag color="blue" style={{ fontSize: "12px" }}>
									₱ {record.exam_fee}.00
								</Tag>
							</>
						)}
						filters={
							dataExamCategory && dataExamCategory.data
								? dataExamCategory.data.map((item) => ({
										text: item.category,
										value: item.id,
								  }))
								: []
						}
					/>

					<Table.Column
						title="Semester"
						key="semester"
						dataIndex="semester"
						sorter={(a, b) => a.semester.localeCompare(b.semester)}
						defaultSortOrder="ascend"
						width={150}
						render={(text, record) => <>{record.semester} </>}
					/>
				</Table>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div className="tbl-bottom-filter">
					<div />

					<Flex>
						<TableShowingEntriesV2 />
						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataStudentExam ? dataStudentExam.data.total : 0}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper_ledger_supplier"
						/>
					</Flex>
				</div>
			</Col>

			<ModalReport
				toggleModalReport={toggleModalReport}
				setToggleModalReport={setToggleModalReport}
			/>
		</Row>
	);
}
